import { LogoIconNombreSVG } from "@/Components/Index";
import { Link } from "react-router-dom";

type Props = {
  toLink: string;
  titleCategoria: string;
  toInicio: number;
};

const styles = { fontSize: 30 };

export const HeaderKnowMoreWeb = ({
  toLink,
  titleCategoria,
  toInicio,
}: Props): JSX.Element => {
  return (
    <div className="ps-container">
      <div className="header__lefts">
        <Link className="ps-logo" to={toLink}>
          <LogoIconNombreSVG />
        </Link>
      </div>
      <div className="header__center d-flex justify-content-center mx-auto my-auto align-items-center">
        <h4 className="text-white mt-3">{titleCategoria}</h4>
      </div>
      <div className="header__rights">
        <div className="d-flex justify-content-end align-items-center mx-auto">
          <Link className="header__back mt-2" to={"/"}>
            <i
              className={`${
                toInicio == 0
                  ? "icon-home3 text-white"
                  : "icon-question-circle text-white"
              }`}
              style={styles}></i>
          </Link>
        </div>
      </div>
    </div>
  );
};
